import axios from 'axios'

export default  {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        find({}, payload) {
            return new Promise((resolve, reject) => {
                axios.get(`/public-service-description/${payload}`)
                    .then(res => {
                        resolve(res)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        checkAliasAvailability({}, payload) {
            return new Promise((resolve, reject) => {
                axios.get(`/public-service-description/by_alias/${payload.alias}/check/${payload.id}`)
                    .then(res => {
                        resolve(res)
                    })
                    .catch(error => {
                            reject(error)
                        })
                    })
        },

        getPublicPage({}, payload) {
            return new Promise((resolve, reject) => {
                axios.get(`/public-service-description/by_alias/${payload}`)
                    .then(res => {
                        resolve(res)
                    })
                    .catch(error => {
                            reject(error)
                        })
                    })
        },

        save({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post('/public-service-description', payload, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                })
                    .then(res => {
                        resolve(res)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        delete({}, id) {
          return new Promise((resolve, reject) => {
            axios
              .delete(`/public-service-description/${id}`)
              .then(res => {
                resolve(res)
              })
              .catch(error => {
                reject(error)
              })
          })
        },

        restore({}, id) {
          return new Promise((resolve, reject) => {
            axios
              .put(`/public-service-description/${id}/restore`)
              .then(res => {
                resolve(res)
              })
              .catch(error => {
                reject(error)
              })
          })
        },
    },

    getters: {},
}
